import { Component, ViewChild, ElementRef } from '@angular/core';
import { ButtonWidget as _ButtonWidget } from '../angular2-schema-form-shim';
import { JSONSchema, SchemaButton } from '../types/json-schema';

declare function jQuery( ...args: any[] ): any;

@Component( {
  selector: 'sp-button-widget',
  templateUrl: './button.widget.html',
} )
export class ButtonWidget extends _ButtonWidget {
  schema: JSONSchema;
  button: SchemaButton;

  @ViewChild( 'ref' ) element: ElementRef;

  get classes() {
    let classes = [ 'btn' ];
    classes.push( this.button.class );
    return classes.join( ' ' );
  }

  ngAfterViewInit() {
    if ( this.button.tooltip ) {
      jQuery( this.element.nativeElement ).tooltip( {
        title: this.button.tooltip,
        placement: 'top',
      } );
    }
  }

  ngOnDestroy() {
    if ( this.button.tooltip ) {
      jQuery( this.element.nativeElement ).tooltip( 'destroy' );
    }
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/button.widget.ts